import React from 'react';
import './OverviewCard.scss';
import AnimatedNumber from 'animated-number-react';
import { getValueChangeLabel } from './CustomersCard';
import { ANIMATION_DURATION } from '../../config/DashboardConfig';
import { enLocaleNumberFormatter } from '../../utils';

const OverviewCard = ({ type, title, value, change, showPercentage,showPercentageSyntax, title2, value2, change2, isSpotCheck  }) => {
  return (
    
      <div className={(type !== 'multiple' && type !== 'large') ? "overview-card-container": "overview-card-container-large"}>
        {type !== 'multiple' && (
          <>
          <div className="overview-card-title">{title}</div>
          <AnimatedNumber
            className={(type !== 'multiple' && type !== 'large') ? "overview-card-value": "overview-card-value large"}
            duration={ANIMATION_DURATION}
            value={value}
            formatValue={(input) => {
              if (showPercentage) {
                return `${((input || 0) * 100).toFixed(0)}%`;
              }
              if (showPercentageSyntax) {
                return `${(input || 0).toFixed(0)}%`;
              }
              
              return enLocaleNumberFormatter(input.toFixed(0));
            }}
          />
    
          </>)
        }
        {type === 'multiple' && (
          <>
          <div className="overview-card-title-small">{title}</div>
          <AnimatedNumber
            className="overview-card-value"
            duration={ANIMATION_DURATION}
            value={value}
            formatValue={(input) => {
              if (showPercentage) {
                return `${((input || 0) * 100).toFixed(0)}%`;
              }
              if (showPercentageSyntax) {
                return `${(input || 0).toFixed(0)}%`;
              }
              return enLocaleNumberFormatter(input.toFixed(0));
            }}
          />
          <div className="overview-card-title-small second-title">{title2}</div>
          <AnimatedNumber
            className="overview-card-value"
            duration={ANIMATION_DURATION}
            value={value2}
            formatValue={(input) => {
              if (showPercentage) {
                return `${((input || 0) * 100).toFixed(0)}%`;
              }
              if (showPercentageSyntax) {
                return `${(input || 0).toFixed(0)}%`;
              }
              return enLocaleNumberFormatter(input.toFixed(0));
            }}
          />
          </>)
        }
      
      {getValueChangeLabel(change, isSpotCheck)}
    </div>
    
  );
};
export default OverviewCard;
